import { render, staticRenderFns } from "./PuertasAcceso.vue?vue&type=template&id=795a7b9e"
import script from "./PuertasAcceso.vue?vue&type=script&lang=js"
export * from "./PuertasAcceso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports